import styled from 'styled-components'
import { margin } from 'styled-system'

import Tabs from '@mui/material/Tabs'

export const Container = styled(Tabs)`
  ${margin}
`
